import React from "react";
import * as LucideIcons from "lucide-react";
import { HelpCircle, type LucideProps } from "lucide-react";

export type IconName = keyof typeof LucideIcons;

type IconProps = {
  name: IconName;
} & LucideProps;

const iconLibrary = LucideIcons as unknown as Record<string, React.ComponentType<LucideProps>>;

const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  color = "currentColor",
  className = "",
  strokeWidth = 2,
  ...props
}) => {
  const IconComponent = iconLibrary[name];

  if (!IconComponent) {
    return (
      <HelpCircle
        size={size}
        color="gray"
        strokeWidth={strokeWidth}
        className={className}
        {...props}
      />
    );
  }

  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      {...props}
    />
  );
};

export default Icon;
